import { getLocale, getLocaleOverride } from '@eventbrite/i18n';
import { CheckoutState } from '../state';

export const getDefaultUserCountry = (state: CheckoutState): string =>
    state.app.defaultUserCountry;

export const getLocaleProps = ({ app, event }: CheckoutState) => {
    return {
        locales: app.locales,
        defaultLocale:
            getLocaleOverride() ??
            getLocale({
                eventLocale:
                    ('properties' in event && event.properties.locale) || '',
                appLocale: app.locale,
            }),
    };
};

export const isEventbriteTLD = (state: CheckoutState): boolean =>
    state.app.isEventbriteTLD;

export const getEbDomain = (state: CheckoutState) => state.app?.ebDomain;

export const isTosClickWrapEnabled = (state: CheckoutState) =>
    state.app?.featureFlags?.enableCheckoutTosClickwrap;
